var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 6.73171H13.6C13.6 5.8696 12.8837 5.17073 12 5.17073C11.1163 5.17073 10.4 5.8696 10.4 6.73171ZM9.2 6.73171C9.2 5.22302 10.4536 4 12 4C13.5464 4 14.8 5.22302 14.8 6.73171H19.4C19.7314 6.73171 20 6.99379 20 7.31707C20 7.64036 19.7314 7.90244 19.4 7.90244H18.3447L17.4071 17.3551C17.2583 18.8553 15.966 20 14.421 20H9.57895C8.03403 20 6.74172 18.8553 6.5929 17.3551L5.65526 7.90244H4.6C4.26863 7.90244 4 7.64036 4 7.31707C4 6.99379 4.26863 6.73171 4.6 6.73171H9.2ZM10.8 10.439C10.8 10.1157 10.5314 9.85366 10.2 9.85366C9.86863 9.85366 9.6 10.1157 9.6 10.439V16.2927C9.6 16.616 9.86863 16.878 10.2 16.878C10.5314 16.878 10.8 16.616 10.8 16.2927V10.439ZM13.8 9.85366C14.1314 9.85366 14.4 10.1157 14.4 10.439V16.2927C14.4 16.616 14.1314 16.878 13.8 16.878C13.4686 16.878 13.2 16.616 13.2 16.2927V10.439C13.2 10.1157 13.4686 9.85366 13.8 9.85366ZM7.78733 17.2423C7.87662 18.1424 8.652 18.8293 9.57895 18.8293H14.421C15.348 18.8293 16.1234 18.1424 16.2126 17.2423L17.1391 7.90244H6.86086L7.78733 17.2423Z",
    fill: "#96C11F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/TrashIcon.ec39a05766dadf63fb592126fea50645.svg";
export { ForwardRef as ReactComponent };